import dayjsTZ from "../../../../utils/dayjs";
import { store } from "../../../../store";
import {
  buildReportResult,
  emptyReportResult,
  employeeFullName,
  intervalBounds,
  weekdayKeysInRange,
} from "../reportResult";

/**
 * Missing punches: active (non fixed-salary) employees with no clocking
 * on a weekday in the selected range. One row per missing day.
 */
export const missingPunches = (
  _prev,
  filter,
  columns,
  manualColumns,
  employees,
) => {
  if (!filter) return emptyReportResult(columns, manualColumns);

  const data = store?.getState()?.customReducer?.reportClockings || [];
  const { startTs, endTs } = intervalBounds(filter);
  const weekdays = weekdayKeysInRange(startTs, endTs);

  const byEmployee = new Map();
  for (const d of data) {
    if (!d?.employeeId || !d?.clockInDate) continue;
    if (d.clockInDate < startTs || d.clockInDate > endTs) continue;
    const key = dayjsTZ(d.clockInDate).format("YYYY-MM-DD");
    if (!byEmployee.has(d.employeeId)) byEmployee.set(d.employeeId, new Set());
    byEmployee.get(d.employeeId).add(key);
  }

  const active = (employees || []).filter(
    (e) =>
      e?.employeeStatus === "Aktiv" &&
      e?.employeePayrollType !== "Page Fikse" &&
      (!filter?.employeeId || e.employeeId === filter.employeeId),
  );

  const preFilter = [];
  for (const emp of active) {
    const hireKey = emp?.employeeHireDate
      ? dayjsTZ(emp.employeeHireDate).format("YYYY-MM-DD")
      : null;
    const present = byEmployee.get(emp.employeeId) || new Set();
    for (const day of weekdays) {
      if (hireKey && day < hireKey) continue;
      if (present.has(day)) continue;
      preFilter.push({
        ...emp,
        employee: employeeFullName(emp),
        employeeDepartmentName: emp.employeeDepartmentName || "",
        employeeTeam: emp.employeeTeam || "",
        missingDate: dayjsTZ(day).format("DD/MM/YYYY"),
        dayName: dayjsTZ(day).format("dddd"),
        dayType: "Mungesë",
      });
    }
  }

  preFilter.sort((a, b) => {
    const byName = String(a.employee).localeCompare(String(b.employee), "sq");
    if (byName) return byName;
    return dayjsTZ(a.missingDate, "DD/MM/YYYY").valueOf() -
      dayjsTZ(b.missingDate, "DD/MM/YYYY").valueOf();
  });

  return buildReportResult(preFilter, columns, manualColumns);
};
